export default __webpack_public_path__ + "static/media/clover-leaf.2002e58f.png";